export default __webpack_public_path__ + "static/media/nft-video.e7db0b76.mp4";